import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { IonDatetime } from '@ionic/vue';
import { ref, watch } from 'vue';
import { convertTimeToISO8601, formatDate } from '@/utils/dates';
export default /*#__PURE__*/_defineComponent({
  __name: 'AppDatetime',
  props: {
    modelValue: {},
    opts: {}
  },
  emits: ["update:modelValue"],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const datetimeValue = ref(props.modelValue);
    /**
     * Converts the date from a `DatetimeCustomEvent` to the format specified in the `opts` prop, then emits it.
     */
    function emitDateWithFormat(value) {
      var _props$opts;
      let date = '';
      if (!((_props$opts = props.opts) !== null && _props$opts !== void 0 && _props$opts.format)) date = value != null ? String(value) : '';else if (value) date = formatDate(String(value), props.opts.format);
      emit('update:modelValue', date);
    }
    /**
     * Prevent the keyboard from showing when the input is focused
     */
    function preventKeyboard(event) {
      event.preventDefault();
      const el = event.target;
      el.blur(); // Remove focus to prevent keyboard
    }
    watch(() => props.modelValue, newValue => {
      var _props$opts2;
      if (newValue && (_props$opts2 = props.opts) !== null && _props$opts2 !== void 0 && _props$opts2.format) datetimeValue.value = convertTimeToISO8601(newValue);else datetimeValue.value = newValue;
    }, {
      immediate: true
    });
    watch(datetimeValue, value => {
      if (value !== props.modelValue) emitDateWithFormat(value);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(IonDatetime), _mergeProps({
        ..._ctx.opts
      }, {
        value: datetimeValue.value,
        preferWheel: "",
        onIonChange: _cache[0] || (_cache[0] = e => emitDateWithFormat(e.detail.value)),
        class: ['inline-datetime', {
          disabled: _ctx.$attrs.disabled
        }],
        onIonFocus: preventKeyboard,
        mode: "ios"
      }), null, 16, ["value", "class"]);
    };
  }
});